import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Form, Modal, Input, DatePicker, Select, Switch, Divider, message, Button, Radio, AutoComplete, Popconfirm, Checkbox, Space } from 'antd';
import { CloseCircleTwoTone, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PhoneOutlined } from "@ant-design/icons";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import CalendarWithSwiper from './CalendarWithSwiper';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/store';
import esLocale from '@fullcalendar/core/locales/es';
import dayjs from 'dayjs';
import 'swiper/css';
import 'swiper/css/pagination';
import '../../styles/pages/calendar/FullCalendarStyles.css'
import { createCita, deleteCita, fetchCitas, updateCita } from '../../redux/actions/citas/citas';
import { fetchUsuarios } from '../../redux/actions/usuarios/usuarios';
import { fetchSucursales } from '../../redux/actions/sucursales/sucursales';
import { createPaciente, fetchPacientes } from '../../redux/actions/pacientes/Pacientes';
import { fetchServiciosClinicos } from '../../redux/actions/servicios_clinicos/Servicios_clinicos';
import { CitaDto } from '../../types/citas/Citas';
import OptionsSucursales from './Components/OptionsSucursales';

const COLORS = {
  NORMAL_CITA: {
    backgroundColor: "#3498db",
    borderColor: "#2980b9"
  },
  GOOGLE_CALENDAR: {
    backgroundColor: "#00c5be",
    borderColor: "#007a73"
  }
};

const CalendarWithEvents: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { rex_citas, rex_tipo } = useSelector((state: RootState) => state.citas);
  const { rex_usuarios_options } = useSelector((state: RootState) => state.usuarios);
  const { rex_sucursales_options } = useSelector((state: RootState) => state.sucursales);
  const { rex_pacientes_options } = useSelector((state: RootState) => state.pacientes);
  const { rex_servicios_clinicos_options } = useSelector((state: RootState) => state.servicios_clinicos);
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs>(dayjs());
  const calendarRef = useRef<FullCalendar | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [selectedUsuario, setSelectedUsuario] = useState<string>();
  const [selectedSucursal, setSelectedSucursal] = useState<string>();
  const [selectedPaciente, setSelectedPaciente] = useState<string>();
  const [selectedProximos, setProximosServicios] = useState<any>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedCita, setSelectedCita] = useState<CitaDto | null>(null);
  const [serviciosSeleccionados, setServiciosSeleccionados] = useState<string[]>([]);
  const { confirm } = Modal;



  console.log('rex_tipo:', rex_tipo)

  useEffect(() => {
    dispatch(fetchUsuarios())
  }, [])

  useEffect(() => {
    dispatch(fetchSucursales())
  }, [])

  useEffect(() => {
    dispatch(fetchPacientes())
  }, [])

  useEffect(() => {
    dispatch(fetchServiciosClinicos())
  }, [])

  useEffect(() => {
    dispatch(fetchCitas(serviciosSeleccionados))
  }, [serviciosSeleccionados])

  const showModal = () => setIsModalVisible(true);

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
    setIsSubmitting(false);

  };

  const validateTime = (time: dayjs.Dayjs): boolean => {
    if (!time) return false;
    const hours = time.hour();
    const minutes = time.minute();
    return !(hours === 0 && minutes === 0);
  };



  const handleOk = async () => {
    form.validateFields()
      .then(async values => {
        if (!validateTime(values.start)) {
          message.error('La hora de inicio no puede ser 00:00');
          return;
        }

        if (!validateTime(values.end)) {
          message.error('La hora de fin no puede ser 00:00');
          return;
        }

        const Cita = {
          usuarioId: values.usuarioId,
          sucursalId: values.sucursalId,
          pacienteId: values.pacienteId,
          title: values.title,
          description: values.description,
          usuarioid_created_at: values.usuarioid_created_at,
          tipo: values.tipo,
          start: values.start,
          end: values.end,
          serviciosIds: values.serviciosIds,
          cedula: values.cedula
        };

        const Paciente = {
          nombre: values.nombre,
          apellidos: values.apellidos,
          cedula: values.cedula,
          celular: values.celular
        }

        if (isEditMode && selectedCita?.id) {
          dispatch(updateCita((selectedCita.id), Cita));
          setIsModalVisible(false);
          form.resetFields();
        } else {
          try {
            const response = await dispatch(createCita(Cita) as any);
            if (response?.tipo === 'warning') {
              confirm({
                title: 'Paciente no encontrado',
                icon: <ExclamationCircleOutlined />,
                content: response.message || 'El paciente no existe, ¿desea crearlo?',
                okText: 'Crear paciente',
                cancelText: 'Cancelar',
                onOk() {
                  dispatch(createPaciente(Paciente))
                },
                onCancel() {
                  message.warning('Creación de cita cancelada.');
                },
              });
              return; 
            }
            setIsModalVisible(false);
            form.resetFields();
          } catch (error) {
            console.error('Error al crear la cita:', error);
          }
        }
      })
      .catch(errorInfo => {
        console.error('Validation Failed:', errorInfo);
        setIsSubmitting(false);
      });
  };


  const handleDeleteEvent = () => {
    if (selectedCita) {
      dispatch(deleteCita(String(selectedCita.id)))

      setIsModalVisible(false)
    }
  }

  const handleSelectChangServicios = (value: any, option: any) => {
    setProximosServicios((prev: any) => {
      const indexFind = prev.findIndex((proximo: any) => proximo.value === option.value)
      let newList;
      if (indexFind !== -1) {
        newList = prev.map((proximo: any, index: number) =>
          index === indexFind ? { ...proximo, ...option } : proximo
        );
      } else {
        newList = [...prev, option];
      }
      const onlyValues = newList.map((item: any) => item.value);
      form.setFieldsValue({ serviciosIds: onlyValues });

      return newList;
    });
  }

  const handleDateClick = (arg: any) => {
    setSelectedDate(dayjs(arg.date));
    setProximosServicios([]);
    setIsEditMode(false);
    const defaultStartTime = dayjs(arg.dateStr).hour(0).minute(0);
    const defaultEndTime = dayjs(arg.dateStr).hour(0).minute(0);

    form.setFieldsValue({
      start: defaultStartTime,
      end: defaultEndTime
    });
    showModal();
  };

  const handleEventClick = (info: any) => {
    console.log('info:', info)
    setIsEditMode(true);
    setIsModalVisible(true);
    const citaSeleccionada = rex_citas.find(cita => Number(cita.id) === Number(info.event.id));

    if (citaSeleccionada) {
      setSelectedCita(citaSeleccionada);
    }
    const serviciosFormateados = info.event._def.extendedProps.citas_servicios.map((item: any) => ({
      value: item.servicioClinicoId,
      label: item.servicio_clinico?.nombre ?? 'Servicio sin nombre'
    }));

    setProximosServicios(serviciosFormateados)
    form.setFieldsValue({
      title: info.event._def.title,
      pacienteId: info.event._def.extendedProps.pacienteId,
      cedula: info.event._def.extendedProps.pacientes.cedula,
      nombre: info.event._def.extendedProps.pacientes.nombre,
      apellidos: info.event._def.extendedProps.pacientes.apellidos,
      celular: info.event._def.extendedProps.pacientes.celular,
      usuarioId: info.event._def.extendedProps.usuarioId,
      sucursalId: info.event._def.extendedProps.sucursalId,
      tipo: info.event._def.extendedProps.tipo,
      start: dayjs(info.event.start),
      end: dayjs(info.event.end),
      description: info.event._def.extendedProps.description,
      serviciosIds: serviciosFormateados.map((servicio: any) => servicio.value)
    });
  }

  const handlePacienteChange = (value: any) => {
    const selected = rex_pacientes_options.find((paciente) => paciente.label === value);
    console.log('selected:', selected)
    if (selected) {
      setSelectedPaciente(selected.value);
      form.setFieldsValue({ cedula: selected.cedula });
      form.setFieldsValue({ pacienteId: selected.pacienteId });
      form.setFieldsValue({ nombre: selected.nombre });
      form.setFieldsValue({ apellidos: selected.apellidos });
      form.setFieldsValue({ celular: selected.celular });
    }
  };


  return (
    <>
      <Row gutter={16}>
        <Col xs={24} md={16}>
          <div className="calendar-wrapper bg-white dark:bg-black rounded-lg p-4 flex flex-col gap-6 relative">
            <OptionsSucursales
              options={rex_sucursales_options}
              selectedValues={serviciosSeleccionados}
              onChange={setServiciosSeleccionados}
            />
            <FullCalendar
              ref={calendarRef}
              events={rex_citas}
              eventClick={handleEventClick}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              locale={esLocale}
              initialView="timeGridDay"
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay',
              }}
              dateClick={handleDateClick}
              selectable={true}
              editable={true}
              initialDate={selectedDate.format('YYYY-MM-DD')}
              dayMaxEvents={3}

            />
          </div>
        </Col>
        <Col xs={24} md={8}>
          <CalendarWithSwiper
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        </Col>
      </Row >
      <Modal
        title={isEditMode ? "Editar Cita" : "Agendar Cita"}
        open={isModalVisible}
        width={"90vh"}
        onCancel={handleCancel}
        footer={[
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}>
            <Button
              type="default"
              icon={<PhoneOutlined />}
            // onClick={handleContactarPaciente}
            >
              Contactar
            </Button>

            <div style={{ display: 'flex', gap: 8 }}>
              {isEditMode && (
                <Popconfirm
                  key="delete"
                  title="¿Está seguro de eliminar este evento?"
                  onConfirm={handleDeleteEvent}
                  okText="Sí"
                  cancelText="No"
                >
                  <Button danger icon={<DeleteOutlined />}>
                    Eliminar
                  </Button>
                </Popconfirm>
              )}
              {isEditMode && (
                <Popconfirm
                  key="update"
                  title="¿Está seguro de actualizar este evento?"
                  onConfirm={handleOk}
                  okText="Sí"
                  cancelText="No"
                >
                  <Button
                    icon={<EditOutlined />}
                    style={{
                      backgroundColor: '#fadb14',
                      borderColor: '#fadb14',
                      color: '#000',
                    }}
                  >
                    Actualizar
                  </Button>

                </Popconfirm>
              )}
              <Button key="cancel" onClick={handleCancel}>
                Cancelar
              </Button>
              <Button
                key="submit"
                type="primary"
                loading={isSubmitting}
                onClick={handleOk}
              >
                Aceptar
              </Button>
            </div>
          </div >
        ]}
        style={{ width: "90vh" }}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="title"
            label="Título"
            rules={[{ required: true, message: 'Por favor ingresa un nombre' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="pacienteId" style={{ display: 'none' }}>
            <Input type="hidden" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="cedula"
                label="Nro cédula"
              >
                <AutoComplete
                  allowClear
                  showSearch
                  placeholder="Seleccionar paciente"
                  // onChange={setSelectedSucursal}
                  options={rex_pacientes_options}
                  filterOption={(inputValue, option) => {
                    const words = inputValue.toLowerCase().split(" ");
                    const fullText = `${option?.key} ${option?.searchText}`.toLowerCase();
                    return words.every(word => fullText.includes(word));
                  }}
                  onSelect={(value, key) => {
                    console.log('key:', key)
                    handlePacienteChange(key.key);
                  }}
                >
                </AutoComplete>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="nombre"
                label="Nombre"
              >
                <Select
                  onChange={handlePacienteChange}
                  optionFilterProp="label"
                >

                </Select>

              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="apellidos"
                label="Apellidos"
              >
                <Select
                >

                </Select>

              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="celular"
                label="Celular"
              >
                <Select
                  onChange={setSelectedPaciente}
                  options={rex_pacientes_options}>
                </Select>

              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="usuarioId"
                label="Doctor"
              >
                <Select
                  value={selectedUsuario}
                  onChange={setSelectedUsuario}
                  options={rex_usuarios_options}>

                </Select>

              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="sucursalId"
                label="Sucursal"
              >
                <Select
                  value={selectedSucursal}
                  onChange={setSelectedSucursal}
                  options={rex_sucursales_options}>

                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="tipo"
            label="Tipo"
            rules={[{ required: true, message: 'Por favor selecciona el tipo de cita' }]}
          >
            <Radio.Group>
              <Radio value="TERAPIA">Terapia</Radio>
              <Radio value="CONSULTA">Consulta</Radio>
            </Radio.Group>
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="start"
                label="Fecha Inicio"
                rules={[
                  { required: true, message: 'Selecciona una fecha' },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.reject();
                      if (!validateTime(value)) {
                        return Promise.reject('La hora no puede ser 00:00');
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <DatePicker
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="end"
                label="Fecha Final"
                rules={[
                  { required: true, message: 'Selecciona una fecha' },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.reject();
                      if (!validateTime(value)) {
                        return Promise.reject('La hora no puede ser 00:00');
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <DatePicker
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  style={{ width: '100%' }} />
              </Form.Item>
            </Col>

          </Row>

          <Form.Item
            name="description"
            label="Descripción"
          >
            <Input.TextArea rows={3} />
          </Form.Item>

          <div className="form-row mb-4 mt-2">
            <div className="form-group col-md-12">
              <label htmlFor="tags">Servicios a realizar</label>
              <Form.Item
                name="serviciosIds"
                rules={[{ required: true, message: "Debes seleccionar al menos un servicio" }]}
              >
                <Select
                  showSearch
                  style={{
                    width: '100%', color: 'transparent',
                    background: 'white !important'
                  }}

                  onChange={handleSelectChangServicios}
                  options={rex_servicios_clinicos_options}
                // filterOption={(input, option) => {
                //   const searchTerms = input.toLowerCase().split(' ');
                //   return searchTerms.every(term =>
                //     (option?.label ?? '').toLowerCase().includes(term)
                //   );
                // }}
                />
              </Form.Item>

              <div style={{ display: 'ruby', marginTop: '10px', marginBottom: '10px' }}>
                {
                  selectedProximos.map((servicio: any) => {
                    return (
                      <div
                        key={servicio.value}
                        style={{
                          color: 'black',
                          background: 'white',
                          border: '1px solid gray',
                          paddingTop: '5px',
                          paddingBottom: '5px',
                          paddingLeft: '10px',
                          paddingRight: '10px',
                          borderRadius: '20px',
                          display: 'flex',
                          marginRight: '5px',
                          marginTop: '5px'
                        }}
                      >
                        {servicio.label}
                        <div
                          style={{
                            marginLeft: '5px',
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            const newServicios = selectedProximos.filter((serv: any) => serv.value !== servicio.value);
                            setProximosServicios(newServicios)
                            form.setFieldsValue({ serviciosIds: newServicios });
                          }}
                        >
                          <CloseCircleTwoTone twoToneColor="#eb2f96" />
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </Form>
      </Modal >
    </>
  );
};

export default CalendarWithEvents;